/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import AuditSheet from './components/AuditSheet';
import AuditSheetFooter from './components/AuditSheetFooter';
import Topbar from './components/Topbar';
import {
  Box,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Spinner,
  useBoolean,
  Text,
  VStack
} from '@chakra-ui/react';
import AppColors from '../../constants/AppColors';
import { withProvider } from '../../hoc/withProvider';
import { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AuditSheetProvider, {
  AuditSheetContext,
} from '../../providers/AuditSheetProvider';
import { createEmptyObject } from './components/createEmptyObject';
import { AWAITING_AUDIT, QA } from '../../constants/constants';
import { sanitize } from './components/sanitize';
import SubmitModal from './components/SubmitModal';
import SendToAuditorModal from './components/SendToAuditorModal';
import ROUTES from '../../constants/Routes';
import { useToastr } from '@laxmimanogna/code-quick-components';
import { successToast } from '../../components/successToast';
import { submitRule } from './components/submitRules';
import CommentBox from './components/CommentBox';
import html2canvas from 'html2canvas';
import { createEmptyColumn } from './utils/commonAuditSheet.utils';
import { arrangeData } from './utils/arrangeAuditSheetData';
import { prepareUpdatePayload } from './utils/preparePayload';
import { AccessDenied } from '../dashboard/components/AccessDenied';
import { AuthContext } from '../../providers/AuthProvider';
import { READ_ONLY_SHEET_STATUSES } from './utils/constant';

const AuditSheetContainer = ({ view, batch }) => {
  // component - utils
  const auditSheetCount = Math.ceil(window.innerHeight / 24);
  const location = useLocation();

  // refs
  const domEl = useRef(null);
  const topbar = useRef(null);
  const footer = useRef(null);
  const notesDrawerRef = useRef(null);

  // booleans
  const [isLoading, ilState] = useBoolean(false);
  const [isOpen, ioState] = useBoolean(false);
  const [isCommentOpen, icoState] = useBoolean(false);

  // other hooks
  const { uploadId, batchId } = useParams();
  const navigate = useNavigate();
  const toast = useToastr();

  const [batchName, setBatchName] = useState(null);
  const [errMsg, setErrMsg] = useState(null);

  // states
  const [lastSaved, setLastSaved] = useState('');
  const [sheets, setSheets] = useState([
    {
      index: 1,
      sheet_name: 'Sheet1',
      data: createEmptyObject(auditSheetCount),
    },
  ]);
  const [activeSheetIndex, setActiveSheetIndex] = useState(0);
  const [scale, setScale] = useState(1);
  const [metaData, setMetaData] = useState({});
  const [isSubmitDisabled, setSubmitDisabled] = useState(true);
  const [coords, setCoords] = useState({
    x: 0,
    y: 0,
  });

  // context
  const auditSheetContext = useContext(AuditSheetContext);

  const { 
    getAuditUpload, 
    getAuditSheet, 
    currentUpload, 
    getIndustryCodes, 
    getICDCodes, 
    getModifiers, 
    getUsers, 
    users, 
    getAllUsers, 
    getCommentFlag, 
    providerOptions, 
    getComments, 
    setSheetData, 
    getRebuttalSubmitValidation, 
    allComments, 
    setChartBatchId,
    sendToAuditor,
    getAvailableAuditors,
    isAccessDenied,
    isAuditSheetLoading,
    getBatchAuditSheet
  } = auditSheetContext;

  const authContext = useContext(AuthContext);

  //  component - functions
  const sheetNames = sheets.map(s => s?.sheet_name);

  const [canAccessAuditSheet, setcanAccessAuditSheet] = useState(null);

  useEffect(() => {
    const map = {};
    sheets.forEach(sheet => {
      sheet.data.forEach((row, index) => {
        if (row.id) map[row.id] = index + 1;
      });
    });
    setSheetData(map);
  }, [sheets]);

  // get chart uploaded
  const getUpload = async () => {
    if (batch) {
      if (!view) {
        navigate(`${location.pathname}/view`, { replace: true });
        view = true;
      }
      getSheet();
      return;
    }

    if (uploadId) {
      const res = await getAuditUpload(uploadId);

      if (res.error) {
        return ;
      }
      setLastSaved(res.updated_date);
      if (!view) {
        if (READ_ONLY_SHEET_STATUSES.includes(res?.status) || res?.assigned_qa?.id !== authContext.currentUser.id) {
          navigate(`${location.pathname}/view`, { replace: true });
          return;
        }
        auditSheetContext.monitorAuditHour(uploadId);
      }
      // Pre-load comments when chart is in CLIENT REBUTTAL status so the
      // Topbar's "Send to Auditor" button reflects accepted rebuttals without
      // requiring the notes drawer to be opened first.
      if (res.status === 'CLIENT REBUTTAL') {
        auditSheetContext.setCommentFilters({
          uploadId: res.id,
          batchId: res.batch_id,
          reverse: true,
          page: 1,
        });
      }
    }
  };

  const onCommentClick = (selection, dimension, comment, canRebuttal,columnData,selectedCol) => {
    const colIndex=selection[0].start.col
    const rowIndex=selection[0].start.row
    const selectedColumnName = columnData[colIndex]?.data;
    // Use functional update to preserve selectedRowData set by afterSelectionEnd
    setMetaData(prev => ({ ...prev, ...dimension, selection, canRebuttal, selectedColumnName, rowIndex }));

    if (dimension.pageX && dimension.pageY) {
      setCoords({ x: dimension.pageX, y: dimension.pageY });
    }

    comment && icoState.on();
  };

  const onZoom = value => {
    let temp = 1;
    if (value >= 50) {
      temp = (2 * value) / 100;
    } else if (value === 0) {
      temp = 0.3;
    } else {
      temp = (value / 100) * 2;
    }
    setScale(temp);
  };

  const getSheet = async () => {
    if (!isAccessDenied || batch) {
      if (uploadId) {
        const response = await getAuditSheet(uploadId, currentUpload);
        const sheetBatchId = response[0]?.batch_id || response[0]?.batch;
        if (sheetBatchId) setChartBatchId(sheetBatchId);
        
        if (response?.length) {
          const updated = response.map((res, i) => {
            const _reDestructuredData = createEmptyColumn(res.data);

            const reDestructuredData = _reDestructuredData.map(sd => {
              const tempObj = { ...sd, ...sd.additional_attributes };
              tempObj['audited_cpt'] = tempObj['audited_code'];
              delete tempObj.additional_attributes;
              delete tempObj?.audited_code;

              if (tempObj?.enc_dt) {
                  const parts = tempObj.enc_dt.split('-');
                  const year = parseInt(parts[0], 10);
                  const month = parseInt(parts[1], 10) - 1;
                  const day = parseInt(parts[2], 10);
                  const parsedDate = new Date(year, month, day);
            
                  if (!isNaN(parsedDate.getTime())) {
                    const formattedDate = `${(parsedDate.getMonth() + 1).toString().padStart(2, '0')}-${parsedDate.getDate().toString().padStart(2, '0')}-${parsedDate.getFullYear()}`;
                    tempObj.enc_dt = formattedDate;
                  }
              }
              if (!tempObj.hasOwnProperty('icd_agree')){
                tempObj['icd_agree'] = null
              }
              if (!tempObj.hasOwnProperty('icd_disagree')){
                tempObj['icd_disagree'] = null
              }

              return tempObj;
            });

            const _arrangeData = arrangeData(reDestructuredData);

            const updatedData = [
              ..._arrangeData,
              ...createEmptyObject(auditSheetCount - res.data.length),
            ];
            return {
              ...res,
              index: i + 1,
              data: updatedData,
            };
          });
          setSheets(updated);
        }
      } else if (batch) {
          const response = await getBatchAuditSheet(batchId);
          if (response?.error) {
            setErrMsg(response.error);
            return;
          }
    
          if (response.length) {
            setBatchName(response[0].batch_name);
            const updated = response.map((res, i) => {
    
              const _reDestructuredData = createEmptyColumn(res.data);
    
              const reDestructuredData = _reDestructuredData.map(sd => {
                const tempObj = { ...sd, ...sd.additional_attributes };
                tempObj['audited_cpt'] = tempObj['audited_code'];
                delete tempObj.additional_attributes;
                delete tempObj?.audited_code;
    
                if (tempObj?.enc_dt) {
                  const parts = tempObj.enc_dt.split('-');
                  const year = parseInt(parts[0], 10);
                  const month = parseInt(parts[1], 10) - 1;
                  const day = parseInt(parts[2], 10);
                  const parsedDate = new Date(year, month, day);
    
                  if (!isNaN(parsedDate.getTime())) {
                    const formattedDate = `${(parsedDate.getMonth() + 1)
                      .toString()
                      .padStart(2, '0')}-${parsedDate
                      .getDate()
                      .toString()
                      .padStart(2, '0')}-${parsedDate.getFullYear()}`;
                    tempObj.enc_dt = formattedDate;
                  }
                }
                if (!tempObj.hasOwnProperty('icd_agree')){
                  tempObj['icd_agree'] = null
                }
                if (!tempObj.hasOwnProperty('icd_disagree')){
                  tempObj['icd_disagree'] = null
                }
                return tempObj;
              });
    
    
              const _arrangeData = arrangeData(reDestructuredData);
    
    
              const updatedData = [
                ..._arrangeData,
                ...createEmptyObject(auditSheetCount - res.data.length),
              ];
              return {
                ...res,
                index: i + 1,
                data: updatedData,
              };
            });
    
            setSheets(updated);
            disableSubmitFunc(response)
    
          }
        };
      }
  };

  //  life cycle hooks
  useEffect(() => {
    if (!isAccessDenied && !view) {
      getIndustryCodes();
      getICDCodes();
      getModifiers();
      getUsers();
      getAllUsers();
      if (uploadId) {
        auditSheetContext.fetchProviderDropdown(uploadId);
      }
      auditSheetContext.fetchResponseAuditIssues(uploadId);
    }
  }, [canAccessAuditSheet]);

  useEffect(()=>{
      // performing get sheet for single audit sheet view because batch already has their sheet called
      if (!isAccessDenied && uploadId) {
        getSheet();
      }
  
    },[uploadId, isAccessDenied])

  useEffect(() => {
    getUpload();
  }, []);

  useEffect(() => {
      if(!isAccessDenied){
        if (uploadId || batchId) {
          getCommentFlag({ uploadId, batchId })
        }
      }
    }, [uploadId, batchId, isAccessDenied])

  useEffect(() => {
    /**
     * sanitize() will add old_rendering and asign as id to rendering and remove empty rows
     */
    if (!isAccessDenied) {
      const sanitizedSheet = sanitize(sheets, providerOptions);
      disableSubmitFunc(sanitizedSheet);
    }
  }, [isAccessDenied, sheets]);

  // functions

  const downloadImage = async () => {
    // download image
    function dataURIToBlob(dataURI) {
      const splitDataURI = dataURI.split(',');
      const byteString =
        splitDataURI[0].indexOf('base64') >= 0
          ? atob(splitDataURI[1])
          : decodeURI(splitDataURI[1]);
      const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++)
        ia[i] = byteString.charCodeAt(i);

      return new Blob([ia], { type: mimeString });
    }

    const canvas = await html2canvas(domEl.current);
    const dataUrl = canvas.toDataURL('image/png', 1.0);
    return dataURIToBlob(dataUrl);
  };

  const updateCurrentAuditImage = async () => {
    try {
      //submit screenshot    
      const file = await downloadImage();
      const fd = new FormData();
      fd.append('image', file);
      return await auditSheetContext.recentAuditImageUpload(uploadId, fd);
    } catch (err) {

    }

  }

  const onAuditSubmit = async () => {
    // call audit screenshot 
    await updateCurrentAuditImage();
    // create audit sheet
    const sanitizedSheet = sanitize(sheets, providerOptions);

    const payload = prepareUpdatePayload(sanitizedSheet);

    const response = await auditSheetContext.updateAuditSheet(
      payload, //sanitizedSheet,
      uploadId
    );

    if (response) {
      ioState.off();
      navigate(ROUTES.DASHBOARD_V2);
      const toastProps = {
        header: 'Success!',
        description: `${'Audit submitted for Client Review.'}`,
      };
      successToast(toast, toastProps);
    }
  };

  const updateAuditSheet = async (sheetParams, pageChange = false) => {
    let sanitizedSheet = [];

    if (sheetParams) {
      sheets[activeSheetIndex] = sheetParams;
      sanitizedSheet = sanitize(sheets, providerOptions);
    } else {
      sanitizedSheet = sanitize(sheets, providerOptions);
    }

    const payload = prepareUpdatePayload(sanitizedSheet);

    try {
      await auditSheetContext.createAuditSheet(payload, uploadId);
      if (!pageChange) {
        getSheet();
      }
      
      // saving screenshot
      await updateCurrentAuditImage();
      setLastSaved(new Date());
    } catch (err) {
      // console.log({ err })
    }
  };

  const disableSubmitFunc = () => {
    const sanitizedSheet = sanitize(sheets, providerOptions);

    const isEverySanitizedSheetEmpty = sanitizedSheet.every(
      sheet => sheet.data.length === 0
    );
    if (isEverySanitizedSheetEmpty) {
      setSubmitDisabled(true);
    } else {
      const isSubmitable = submitRule(sanitizedSheet);
      setSubmitDisabled(isSubmitable);
    }
  };

  const addNewSheet = async () => {
    const updatedSheets = [
      ...sheets,
      {
        index: sheets.length + 1,
        data: createEmptyObject(auditSheetCount),
        sheet_name: `Sheet${sheets.length + 1}`,
      },
    ];
    setSheets([...updatedSheets]);
    setActiveSheetIndex(sheets.length);
  };

  const changeSheetName = async (index, name) => {
    sheets[index] = { ...sheets[index], sheet_name: name };
    setSheets([...sheets]);
    const sanitizedSheet = sanitize(sheets, providerOptions);
    await auditSheetContext.createAuditSheet(sanitizedSheet, uploadId);
  };

  const onLeftNavigate = () => {
    if (activeSheetIndex > 0) {
      setActiveSheetIndex(activeSheetIndex - 1);
    }
  };

  const onRightNavigate = () => {
    if (activeSheetIndex < sheets.length - 1) {
      setActiveSheetIndex(activeSheetIndex + 1);
    }
  };

  const updateSheet = sheetData => {
    sheets[activeSheetIndex].data = sheetData;
    setSheets([...sheets]);
  };

  const removeRows = rowIndexes => {
    const data = sheets[activeSheetIndex].data.map((obj, i) =>
      rowIndexes.includes(i) ? {} : obj
    );
    sheets[activeSheetIndex].data = data;
    setSheets([...sheets]);
  };

  const onDeleteSheet = async index => {
    if (sheets.length > 1) {
      let sheetIndex = 1;
      let newSheet = [];
      sheets.map((p, i) => {
        if (index !== i) {
          newSheet.push({ ...p, index: sheetIndex });
          sheetIndex = sheetIndex + 1;
        }
      });
      setSheets([...newSheet]);
      if (activeSheetIndex === index && index > 0) {
        const data = activeSheetIndex - 1;
        setActiveSheetIndex(data);
      }
      const sanitizedSheet = sanitize(newSheet, providerOptions);
      await auditSheetContext.createAuditSheet(sanitizedSheet, uploadId);
    }
  };

  const onRebuttalClick = async () => {
    if (!metaData.selection?.length) {
      toast.showError({ description: 'Please click on a row to view a rebuttal.' });
      return;
    }
    const { start, end } = metaData.selection[0];
    if (start.row !== end.row) {
      toast.showError({ description: 'Please select cells within a single row to view a rebuttal.' });
      return;
    }
    const rowData = metaData.selectedRowData;
    if (!rowData?.id) {
      toast.showError({ description: 'Please select a valid row.' });
      return;
    }
    setMetaData(prev => ({ ...prev, rowIndex: start.row }));
    const chartId = rowData?.chart_id;
    await auditSheetContext.getComments({ batchId, uploadId: uploadId || chartId, row: [rowData.id] });
    icoState.on();
  };

  const [isSendToAuditorOpen, setIsSendToAuditorOpen] = useState(false);
  const [isSendToAuditorLoading, issaState] = useBoolean(false);

  const onSendToAuditorClick = () => setIsSendToAuditorOpen(true);

  const onSendToAuditorConfirm = async (auditorId) => {
    issaState.on();
    await sendToAuditor(uploadId, auditorId);
    issaState.off();
    setIsSendToAuditorOpen(false);
  };

  const onOpenNotes = obj => {
    if (obj && Object.keys(obj).length) {
      if (obj.all) {
        delete auditSheetContext.commentFilters.sheet_name;
        auditSheetContext.setCommentFilters({
          ...auditSheetContext.commentFilters,
          page: 1,
        });
      } else if (obj.current) {
        auditSheetContext.setCommentFilters({
          ...auditSheetContext.commentFilters,
          sheet_name: sheets[activeSheetIndex].sheet_name,
          page: 1,
        });
      }
    } else {
      auditSheetContext.setCommentFilters({
        ...auditSheetContext.commentFilters,
        uploadId,
        batchId,
        sheet_name: sheets[activeSheetIndex].sheet_name,
        reverse: true,
        page: 1,
      });
    }
  };

  function handleSheetClick(e) {
    setCoords({
      x: e.clientX,
      y: e.clientY,
    });
  }

  //  components - render's

  const renderTopbar = () => {
    return (
      <Box w={'100%'} ref={topbar}>
        <Topbar
          onAuditSubmit={async () => {
            const validation = await getRebuttalSubmitValidation(uploadId);
            if (validation && validation.can_submit === false) {
              toast.showError({ description: 'Cannot submit: there are open or unresolved rebuttal threads.' });
              return;
            }
            ioState.on();
          }}
          updateAuditSheet={async params => {
            await updateAuditSheet(params);
          }}
          handleGoingBack={async params => {
            await updateAuditSheet(params, true);
          }}
          view={view}
          disableSubmit={isSubmitDisabled}
          lastSaved={lastSaved}
          onChange={on => {
            if (on) {
              ilState.on();
            } else {
              ilState.off();
            }
          }}
          onRebuttalClick={onRebuttalClick}
          onOpenNotes={onOpenNotes}
          notesDrawerRef={notesDrawerRef}
          onSendToAuditor={onSendToAuditorClick}
          batchName={batchName}
          batchId={batchId}
          view={view}
        />
        <SendToAuditorModal
          isOpen={isSendToAuditorOpen}
          onClose={() => setIsSendToAuditorOpen(false)}
          onConfirm={onSendToAuditorConfirm}
          specialtyId={currentUpload?.specialties?.id}
          currentAuditor={currentUpload?.assigned_auditor}
          getAvailableAuditors={getAvailableAuditors}
          isLoading={isSendToAuditorLoading}
        />
      </Box>
    );
  };


  const renderAuditSheet = () => {
    return (
      <Box id="domEl" ref={domEl} onClick={handleSheetClick}>
        <AuditSheet
          height={
            window.innerHeight -
            topbar?.current?.clientHeight -
            footer?.current?.clientHeight
          }
          scale={scale}
          sheet={sheets[activeSheetIndex]}
          uploadId={uploadId}
          view={true}
          updateAuditSheet={updateAuditSheet}
          updateSheet={updateSheet}
          onCommentClick={onCommentClick}
          onSelectionEnd={(selection, rowData) => setMetaData(prev => ({ ...prev, selection, selectedRowData: rowData }))}
          removeRows={removeRows}
          closeComment={() => icoState.off()}
          batch={batch}
          batchId={batchId}
        />
      </Box>
    );
  };

  const renderFooter = () => {
    return (
      <Box w={'100%'} position={'fixed'} bottom={0} ref={footer}>
        <AuditSheetFooter
          onSheetChange={setActiveSheetIndex}
          sheets={sheetNames}
          activeSheetIndex={activeSheetIndex}
          addNewSheet={addNewSheet}
          changeSheetName={changeSheetName}
          onLeftNavigate={onLeftNavigate}
          onRightNavigate={onRightNavigate}
          onZoom={onZoom}
          onDeleteSheet={onDeleteSheet}
        />
      </Box>
    );
  };

  const renderSubmitModal = () => {
    return (
      <SubmitModal
        isOpen={isOpen}
        onClose={() => ioState.off()}
        onAuditSubmit={onAuditSubmit}
      />
    );
  };

  const renderModal = () => {
    return (
      <Modal size={'sm'} isOpen={isLoading} isCentered bgColor={'transparent'}>
        <ModalOverlay style={{ backgroundColor: AppColors.lightSkyBlue }} />
        <ModalContent bgColor={'transparent'} shadow={'none'}>
          <ModalBody style={{ alignSelf: 'center' }}>
            <Spinner />
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  };

  const renderCommentBox = () => {
    return (
      <CommentBox
        showMenu={isCommentOpen}
        metaData={metaData}
        closeComment={() => icoState.off()}
        coords={coords}
      />
    );
  };

  return (
    (isAuditSheetLoading ? (
      <VStack height="100vh" justify="center" align="center">
        <Spinner size="xl" />
        <Text>Loading...</Text>
      </VStack>
    ) :
    (!isAccessDenied ? (

      <Box h={'100vh'} bgColor={AppColors.bgColor}>
        {renderTopbar()}
        {renderAuditSheet()}
        {renderFooter()}
        {renderSubmitModal()}
        {renderModal()}
        {renderCommentBox()}
      </Box>
      ) :
      <AccessDenied 
      errMsg={errMsg}/>
      )
    )
  );
};
export default withProvider(AuditSheetProvider, AuditSheetContainer);
